import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ListResultDTO } from 'src/app/helpers/listResult.interface';
import { environment } from 'src/environments/environment';

import { CurrencyDTO } from '../../models/currency.model';
import { CurrencyFilters } from './../../models/currency.model';

@Injectable({
  providedIn: "root"
})
export class LaravelCurrencyService {


  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {
 
      list: environment.baseUrl + "/api/currencies",
      show: environment.baseUrl + "/api/currency",
      store: environment.baseUrl + "/api/currency",
      destroy: environment.baseUrl + "/api/currency",
  
    };
  }

  public list(page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: CurrencyFilters,
    includes?: string[]
  ): Observable<ListResultDTO<CurrencyDTO>> {
    let params = {};
    if (order) params["order"] = "" + order;
    if (direction) params["direction"] = "" + direction;
    if (includes) params["includes[]"] = includes;
    if (filters) {
      if (filters.search) params["search"] = "" + filters.search;
  }
    if (per_page) {
      params["per_page"] = "" + per_page;
      if (page) params["page"] = "" + page;
      return this.httpClient.get<ListResultDTO<CurrencyDTO>>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      });
    } else {
      return this.httpClient.get<CurrencyDTO[]>(this.ROUTES.list, {
        params: new HttpParams({ fromObject: params })
      }).pipe(
        map(results => {
          return {
            data: results,
            total: results.length
          };
        })
      );
    }
  }


  public getCurrencyById(id: number): Observable<CurrencyDTO> {
    let params = { id: "" + id };
    return this.httpClient.get<CurrencyDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params
      })
    });

  }

  public upsert(currency: CurrencyDTO): Observable<CurrencyDTO> {
    if (currency.id) {
      return this.httpClient.put<CurrencyDTO>(`${this.ROUTES.store}`, { currency });
    } else {
      return this.httpClient.post<CurrencyDTO>(`${this.ROUTES.store}`, { currency });
    }
  }

  public delete(id: number): Observable<any> {
    let params = { id: "" + id };
    return this.httpClient.delete(this.ROUTES.destroy, {
      params: new HttpParams({
        fromObject: params
      })
    });
  }
}
